import React from "react";
import { Lightbulb, Palette, Settings, Rocket, Video } from "lucide-react";
import { useLanguage } from "../../i18n";

const ProcessSection = () => {
  const { t } = useLanguage();
  const processSteps = t('process.steps');
  const icons = [Lightbulb, Palette, Settings, Rocket, Video];
  
  const steps = Array.isArray(processSteps) 
    ? processSteps.map((step, index) => ({
        number: String(index + 1).padStart(2, '0'),
        icon: icons[index] || Rocket,
        title: step.title,
        description: step.description
      }))
    : [
        { number: "01", icon: Lightbulb, title: "Concepto creativo", description: "Diseñamos la idea y narrativa visual del show." },
        { number: "02", icon: Palette, title: "Diseño de coreografía", description: "Creamos las animaciones y secuencias de drones." },
        { number: "03", icon: Settings, title: "Producción", description: "Coordinamos logística, permisos y operación." },
        { number: "04", icon: Rocket, title: "Ejecución", description: "Realizamos el espectáculo en el evento." },
        { number: "05", icon: Video, title: "Contenido viral", description: "Creamos contenido profesional para redes sociales." },
      ];

  return (
    <section id="proceso" className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t('process.title')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              {t('process.titleHighlight')}
            </span>
          </h2>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector line - only on desktop */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-full h-[2px] bg-gradient-to-r from-cyan-500/50 to-transparent" />
              )}
              
              <div className="text-center">
                <div className="relative inline-block mb-4 md:mb-6">
                  <div className="w-16 h-16 md:w-24 md:h-24 rounded-2xl bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border border-cyan-500/30 flex items-center justify-center">
                    <step.icon className="w-7 h-7 md:w-10 md:h-10 text-cyan-400" />
                  </div>
                  <span className="absolute -top-2 -right-2 w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white text-xs md:text-sm font-bold">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-lg font-bold text-white mb-1 md:mb-2">{step.title}</h3>
                <p className="text-gray-400 text-xs md:text-sm">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
